import { render, staticRenderFns } from "./FieldFileByTransferId.vue?vue&type=template&id=534e398d&scoped=true&"
import script from "./FieldFileByTransferId.vue?vue&type=script&lang=js&"
export * from "./FieldFileByTransferId.vue?vue&type=script&lang=js&"
import style0 from "./FieldFileByTransferId.vue?vue&type=style&index=0&id=534e398d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534e398d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('534e398d')) {
      api.createRecord('534e398d', component.options)
    } else {
      api.reload('534e398d', component.options)
    }
    module.hot.accept("./FieldFileByTransferId.vue?vue&type=template&id=534e398d&scoped=true&", function () {
      api.rerender('534e398d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldFileByTransferId.vue"
export default component.exports